/** @jsxImportSource @emotion/react */
import { TableBody } from "../../../../components/table-components/TableBody";
import { Table } from "../../../../components/table-components/Table";
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { colors } from "../../../../components/colors";
import { TableRow } from "../../../../components/table-components/TableRow";
import { TableCellLink } from "../../../../components/table-components/TableCellLink";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { StyledText } from "../../../../assets/typography/typography";
import { TableEllipsisDropdown } from "../../../../components/TableEllipsisDropdown";
import { ProductGroupListItem } from "../models/ProductGroup";
import { useDeleteProductGroup } from "../service/product-groups-api";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getErrorMessage } from "../../../../error-handler";
import { toastr } from "react-redux-toastr";
import { DropdownItemButton } from "../../../common/DropdownItemButton";
import { DropdownItemLink } from "../../../common/DropdownItemLink";

type Props = {
  productGroups: ProductGroupListItem[];
};

export const ProductGroupsTable = ({ productGroups }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { mutateAsync: deleteProductGroup } = useDeleteProductGroup();

  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText>Name</TableCellHeaderText>
          <TableCellHeaderText>Country</TableCellHeaderText>
          <TableCellHeaderText>No of products</TableCellHeaderText>
          <th />
        </TableRowHeader>
      </thead>
      <TableBody>
        {productGroups.map((productGroup, i) => {
          const href = routes.productGroupEdit(
            organizationKeyName,
            productGroup.id
          );

          return (
            <TableRow key={i}>
              <TableCellLink href={href} className="pl-5">
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {productGroup.name}
                </StyledText>
              </TableCellLink>
              <TableCellLink href={href}>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {productGroup.countryAlpha2Code || "-"}
                </StyledText>
              </TableCellLink>
              <TableCellLink href={href}>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {productGroup.products.length}
                </StyledText>
              </TableCellLink>
              <TableEllipsisDropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      label: (
                        <DropdownItemLink
                          icon={<FontAwesomeIcon icon={solid("pen")} />}
                          to={href}
                        >
                          Edit
                        </DropdownItemLink>
                      ),
                    },
                    {
                      key: "2",
                      label: (
                        <DropdownItemButton
                          icon={<FontAwesomeIcon icon={solid("trash")} />}
                          onClick={async () => {
                            try {
                              await deleteProductGroup({
                                organizationKeyName,
                                data: {
                                  id: productGroup.id,
                                },
                              });
                              toastr.success(
                                "Success",
                                "Product group deleted"
                              );
                            } catch (error) {
                              const errorMessage = getErrorMessage(error);
                              toastr.error("Error", errorMessage);
                            }
                          }}
                        >
                          Delete
                        </DropdownItemButton>
                      ),
                    },
                  ],
                }}
              />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
